import axios from "axios";
const accessToken = "511115e80a19b617ec936ee134cbc0ae";

const headerDelete = {
  Accept: "application/vnd.vimeo.*+json;version=3.4",
  Authorization: `bearer ${accessToken}`,
  "Content-Type": "application/x-www-form-urlencode"
};

const headerPatch = {
  "Tus-Resumable": "1.0.0",
  "Upload-Offset": 0,
  "Content-Type": "application/offset+octet-stream",
  Accept: "application/vnd.vimeo.*+json;version=3.4"
};

const headerPost = {
  Accept: "application/vnd.vimeo.*+json;version=3.4",
  Authorization: `bearer ${accessToken}`,
  "Content-Type": "application/json"
};
export default {
  data() {
    return {
      progress: 0,
      uploadingVideo: false
    };
  },
  methods: {
    uploadVideo(file, name, description) {
      return new Promise(async (resolve, reject) => {
        this.uploadingVideo = true;
        const vimeoURL = "https://api.vimeo.com/me/videos";
        const fileSize = file.size.toString();

        const response = await axios({
          method: "post",
          url: vimeoURL,
          headers: headerPost,
          data: {
            name: name,
            description: description,
            upload: {
              approach: "tus",
              size: fileSize
            },
            privacy: {
              download: false,
              embed: "public",
              view: "anybody"
            }
          }
        });

        let tus = require("tus-js-client");
        const upload = new tus.Upload(file, {
          endPoint: vimeoURL,
          uploadUrl: response.data.upload.upload_link,
          retryDelays: [0, 3000, 5000, 10000, 20000],
          metadata: {
            filename: name,
            filetype: file.type
          },
          headers: {},
          onError: error => {
            this.uploadingVideo = false;
            reject(error);
            //@TODO:Log Errors in Firebase Log  -- error
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            this.uploadingVideo = true;
            let percentage = (bytesUploaded / bytesTotal) * 100;
            this.progress = parseInt(percentage);
          },
          onSuccess: () => {
            this.uploadingVideo = false;
            const dataLinkParts = response.data.link.split("/");
            resolve({
              videoName: upload.file.name,
              vimeoURL: response.data.link,
              videoId: dataLinkParts[3],
              vimeoName: name
            });
          }
        });
        upload.start();
      });
    },
    getVideoThumbnail(videoId) {
      return new Promise((resolve, reject) => {
        const vimeoURL = "https://api.vimeo.com";
        let videoGetThumbnail = `${vimeoURL}/videos/${videoId}/pictures`;
        let getVideoStats = `${vimeoURL}/videos/${videoId}?fields=uri,upload.status,transcode.status`;

        let callInterval = setInterval(() => {
          axios({
            method: "get",
            url: getVideoStats,
            headers: headerPost
          })
            .then(res => {
              axios({
                method: "get",
                url: videoGetThumbnail,
                headers: headerPost
              })
                .then(res => {
                  if (
                    res.data.data[0] &&
                    res.data.data[0].sizes[3].link_with_play_button
                  ) {
                    clearInterval(callInterval);
                    resolve(res.data.data[0].sizes[3].link_with_play_button);
                  }
                })
                .catch(e => {
                  console.log(e);
                });
            })
            .catch(e => {
              console.log(e);
            });
        }, 4000);
      });
    }
  }
};
